import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import { LoadingOverlay } from "../components/ui/loading-overlay";
import API_URL from "../config";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

const ForgetPassword = () => {
  const [correo, setCorreo] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setCorreo(e.target.value);
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/user/forgetpassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ correo }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(
          errorData.error || "Error en la solicitud. Inténtalo más tarde."
        );
        setMessage("");
        return;
      }

      const data = await response.json();
      setMessage(data.message);
      setError("");
    } catch (error) {
      console.error("Error en la solicitud:", error);
      setError("Error en la conexión con el servidor. Inténtalo más tarde.");
      setMessage("");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingOverlay />;
  }

  return (
    <PageLayout>
      <div className="flex items-center justify-center px-4 py-16">
        <Card className="w-full max-w-md">
          <CardContent className="pt-6">
            <h2 className="text-center text-2xl font-semibold text-foreground">
              Recuperar Contraseña
            </h2>
            <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
              <div>
                <label htmlFor="correo" className="mb-1.5 block text-sm font-medium text-foreground">
                  Correo Electrónico
                </label>
                <Input
                  type="email"
                  name="correo"
                  value={correo}
                  onChange={handleChange}
                  required
                />
              </div>

              <Button type="submit" className="w-full">
                Enviar Correo
              </Button>
              {message && <p className="text-center text-sm font-semibold text-green-600">{message}</p>}
              {error && <p className="text-center text-sm font-semibold text-destructive">{error}</p>}
            </form>

            <p className="mt-6 text-center text-xs text-muted-foreground">
              Al continuar, aceptas las{" "}
              <Link to="/condiciones-uso" className="text-primary hover:underline">
                Condiciones de uso
              </Link>{" "}
              y el{" "}
              <Link to="/aviso-privacidad" className="text-primary hover:underline">
                Aviso de privacidad
              </Link>{" "}
              de Procu.
            </p>
            <p className="mt-4 text-center text-sm">
              ¿Ya tienes una cuenta?{" "}
              <Link to="/login" className="font-semibold text-primary hover:underline">
                Iniciar sesión
              </Link>
            </p>
          </CardContent>
        </Card>
      </div>
    </PageLayout>
  );
};

export default ForgetPassword;
